import { TableBody, TableFooter, TableHead, TableRow } from '@mui/material';
import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { deliveryFee } from '../../../../shared/env';
import { MobileTable } from '../../common/components/MobileTable';
import {
  HscanTable,
  HscanTableCell,
} from '../../common/components/SortableTable';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';
import { krwCurrencyFormatter } from '../../utils';
import { PaymentMobileTableRow } from '../RequestImages/PaymentTable';

export const PaymentTable = () => {
  const isMobile = useContext(WindowSizeContext) === WindowSize.MOBILE;
  return isMobile ? <MobilePaymentTable /> : <WebPaymentTable />;
};

export const WebPaymentTable = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.cd.payment.table',
  });
  return (
    <HscanTable
      head={
        <TableHead>
          <TableRow>
            <HscanTableCell align="center">{t('header.item')}</HscanTableCell>
            <HscanTableCell align="center">{t('header.price')}</HscanTableCell>
          </TableRow>
        </TableHead>
      }
      body={
        <TableBody>
          <TableRow>
            <HscanTableCell align="center" $border="1px solid">
              {t('column.deliveryFee')}
            </HscanTableCell>
            <HscanTableCell align="center" $border="1px solid">
              {t('column.priceField', {
                price: krwCurrencyFormatter(deliveryFee),
              })}
            </HscanTableCell>
          </TableRow>
        </TableBody>
      }
      footer={
        <TableFooter>
          <TableRow>
            <HscanTableCell align="center">
              {t('column.totalPrice')}
            </HscanTableCell>
            <HscanTableCell align="center">
              {t('column.priceField', {
                price: krwCurrencyFormatter(deliveryFee),
              })}
            </HscanTableCell>
          </TableRow>
        </TableFooter>
      }
    />
  );
};

export const MobilePaymentTable = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.cd.payment.table',
  });
  return (
    <div>
      <MobileTable>
        <tbody>
          <PaymentMobileTableRow label={`${t('column.deliveryFee')}`}>
            {t('column.priceField', {
              price: krwCurrencyFormatter(deliveryFee),
            })}
          </PaymentMobileTableRow>
        </tbody>
        <tfoot>
          <PaymentMobileTableRow
            label={
              <Trans
                t={t}
                i18nKey="column.mobileTotalPrice"
                components={[
                  <br />,
                  <span style={{ fontSize: '10px', fontWeight: 300 }} />,
                ]}
              />
            }>
            {t('column.priceField', {
              price: krwCurrencyFormatter(deliveryFee),
            })}
          </PaymentMobileTableRow>
        </tfoot>
      </MobileTable>
    </div>
  );
};
